export default __webpack_public_path__ + "static/media/lab1.ae09fe40.jpg";